export default __webpack_public_path__ + "static/media/milestone 1.a9b62b91.svg";